export default "__VITE_ASSET__CRcwASQv__"